/*
 * @Author: cc
 * @LastEditTime: 2022-06-17 17:21:06
 */
import  { useEffect } from "react";
import { isPc } from "../utils/index";
import "moment/locale/zh-cn";
import { useLocation } from "react-router-dom";
import PcLogin from "./pcLogin/pcLogin"
import MobileLogin from "./mobileLogin/mobileLogin"
import {get} from "../component/fetch"
import store from '../reducers/index'
export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
export interface Category {
  zhName: string;
  enName: string;
  required: boolean;
  fieldType: string;
  tips?: string;
  placeholder?: string;
  selectOptions: string[];
  id: number;
}

const Index = () => {
  const query = useQuery()
  const projectId = query.get('projectId')
  function getInfo() {
    get(`/shop/api/project/${projectId}/login/page/info`,{},true).then(res=>{
      if(isPc){
        document.title = res.data.pcName
      }else{
        document.title = res.data.mobileName
      }
      store.dispatch({
        type:"SET_INIT_INFO",
        ...res.data
      })
    })
  }
  useEffect(() => {
    if(projectId ==="A9008A"){
      window.location.href="https://view.csslcloud.net/api/view/index?roomid=9DBA146EE8AFABDF9C33DC5901307461&userid=D71B0368E20B4CF5"
    }else{
      getInfo()
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div
        className="App"
      >
        {isPc ? <PcLogin></PcLogin> : <MobileLogin></MobileLogin>}
      </div>
    </>
  );
};

export default Index;
